export const _initialState = {
  productInfo: null
};
